// GORCAPA (RMS Cloud) booking strategy.
//
// A site's reserveUrl is its RMS property's dateless landing:
//
//   * drive-in campgrounds: https://bookings12.rmscloud.com/Search/Index/{hex}/1
//     (RMS's classic UI, which opens on the site map)
//   * the Great Ocean Walk:  https://ibe12.rmscloud.com/{hex}/1 (RMS's IBE)
//
// A dated link goes one step deeper. The classic rates page takes the stay
// and preselects the site with `Ar={areaId}`; the IBE takes the stay, filters
// to the camp with `Ct={catId}` and runs the search with `execute=true`.
// Dates are MM/DD/YYYY; ISO dates read as "Invalid date". A classic Rates
// URL without dates redirects to search with an error, so the preview keeps
// the dateless landing.

import { format } from "date-fns";
import { resolveCheckout } from "./_context.js";

const rmsDate = (date) => format(date, "MM/dd/yyyy");

// Great Ocean Walk pads hold three walkers and drive-in sites six; two adults
// is the booking form's own default and fits both.
const DEFAULT_ADULTS = 2;

export default {
  buildBookingUrl(ctx) {
    const { site, arrivalDate, partySize } = ctx;
    const landing = new URL(site.reserveUrl);
    const classic = landing.pathname.startsWith("/Search/Index/");
    const hex = landing.pathname.split("/").filter(Boolean)[classic ? 2 : 0];
    const params = new URLSearchParams({
      A: rmsDate(arrivalDate),
      D: rmsDate(resolveCheckout(ctx)),
      Ad: String(partySize ?? DEFAULT_ADULTS),
    });
    if (classic) {
      if (site.extraAttributes?.areaId != null) {
        params.set("Ar", String(site.extraAttributes.areaId));
      }
      return `${landing.origin}/Rates/Index/${hex}/1?${params}`;
    }
    if (site.extraAttributes?.catId != null) {
      params.set("Ct", String(site.extraAttributes.catId));
    }
    params.set("execute", "true");
    return `${landing.origin}/${hex}/1?${params}`;
  },

  buildPreviewUrl(site) {
    return site.reserveUrl;
  },

  describeBookingInputs() {
    return {
      inputs: {
        arrivalDate: {
          status: "required",
          notes: "Encoded as A=MM/DD/YYYY.",
        },
        departureDate: {
          status: "required",
          notes:
            "Encoded as D=MM/DD/YYYY; resolved from arrival + minStayLength when not supplied.",
        },
        ref: {
          status: "ignored",
          notes:
            "The site is encoded from extraAttributes: Ar (drive-in site) or Ct (Great Ocean Walk camp).",
        },
        partySize: {
          status: "defaulted",
          defaultValue: DEFAULT_ADULTS,
          notes: "Encoded as Ad=<adults>.",
        },
      },
    };
  },
};
